import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "CampaignEditorFrontEnd" }
const _hoisted_2 = { class: "CampaignEditorMainContent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_NavigationBar = _resolveComponent("NavigationBar")!
  const _component_SaveBlock = _resolveComponent("SaveBlock")!
  const _component_TitleBlock = _resolveComponent("TitleBlock")!
  const _component_ErrorModal = _resolveComponent("ErrorModal")!
  const _component_OverlappingCampaignsModal = _resolveComponent("OverlappingCampaignsModal")!
  const _component_UnsafeExitModal = _resolveComponent("UnsafeExitModal")!
  const _component_NotificationStatus = _resolveComponent("NotificationStatus")!
  const _component_LogOut = _resolveComponent("LogOut")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopHeader),
    _createVNode(_component_NavigationBar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SaveBlock),
      (!_ctx.isCampaignCreation)
        ? (_openBlock(), _createBlock(_component_TitleBlock, { key: 0 }))
        : _createCommentVNode("v-if", true),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.CurrentComponent)))
    ]),
    (_ctx.errorActive)
      ? (_openBlock(), _createBlock(_component_ErrorModal, { key: 0 }))
      : _createCommentVNode("v-if", true),
    (_ctx.isOverlap)
      ? (_openBlock(), _createBlock(_component_OverlappingCampaignsModal, { key: 1 }))
      : _createCommentVNode("v-if", true),
    (_ctx.unsafeExitActive)
      ? (_openBlock(), _createBlock(_component_UnsafeExitModal, { key: 2 }))
      : _createCommentVNode("v-if", true),
    (_ctx.notificationActive)
      ? (_openBlock(), _createBlock(_component_NotificationStatus, { key: 3 }))
      : _createCommentVNode("v-if", true),
    (_ctx.standAloneLogin)
      ? (_openBlock(), _createBlock(_component_LogOut, { key: 4 }))
      : _createCommentVNode("v-if", true)
  ]))
}